import { Injectable } from '@angular/core';
import { BaseHTTPHandlerService } from '@services/httpClientAbstract/httpClient.service.abstract';
import { IEmailPayload } from './email.service.types';

@Injectable({
	providedIn: 'root',
})
export class EmailService extends BaseHTTPHandlerService {
	basePath = 'email';

	sendEmail(payload: IEmailPayload) {
		return this.post<void>('send-email', payload);
	}

	addToQueue(payload: IEmailPayload) {
		return this.post<void>('add-to-queue', payload);
	}
}
